(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6887],{

/***/ 66678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 6887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ JustAnImage; },
/* harmony export */   "justAnImageDefaultOpts": function() { return /* binding */ justAnImageDefaultOpts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90257);
/* harmony import */ var _helpers_misc_roundToNearest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24573);
/* harmony import */ var _hooks_useResizedImageURL__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25447);
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9177);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20024);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var justAnImageDefaultOpts = {
    scale: 2,
    width: (0,_helpers_misc_roundToNearest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_hooks_useWidth__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_DESKTOP_WIDTH */ .P, 200) || 400,
    height: null
};
function JustAnImage(props) {
    var ref, ref1;
    var screenWidth = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)();
    var image = screenWidth <= 760 ? props.smallImage || props.image : props.image;
    var url = (0,_hooks_useResizedImageURL__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_objectSpread({}, justAnImageDefaultOpts, {
        width: (0,_helpers_misc_roundToNearest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(screenWidth, 200) || 400,
        fileId: image._id
    }), {
        partial: true
    });
    var finalUrl = url ? url : (ref = props.ssrImage) === null || ref === void 0 ? void 0 : ref.resizedURL;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)() && !((ref1 = props.ssrImage) === null || ref1 === void 0 ? void 0 : ref1.resizedURL)) {
        console.warn("Could not fetch image for JustAnImage component while doing SSR. This should be fixed for an optimized experience");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: finalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: finalUrl,
            alt: ""
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
};


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 24573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RoundToNearest; }
/* harmony export */ });
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_0__);

function RoundToNearest(number, nearest) {
    if (lodash_isNaN__WEBPACK_IMPORTED_MODULE_0___default()(number)) {
        throw new Error("Number is not a number");
    }
    var times = Math.ceil(number / nearest);
    return nearest * times;
};


/***/ }),

/***/ 25447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResizedImageURL; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6909);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50456);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66678);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clone__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getResizedImage(\n        $fileId: ID\n        $scale: Float\n        $width: Float\n        $height: Float\n        $resizeMode: ID\n        $background: String\n        $format: String\n      ) {\n        image(fileId: $fileId) {\n          _id\n          resizedURL(\n            scale: $scale\n            width: $width\n            height: $height\n            resizeMode: $resizeMode\n            background: $background\n            format: $format\n          )\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function useResizedImageURL(opt) {
    var queryOpts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = lodash_clone__WEBPACK_IMPORTED_MODULE_1___default()(opt);
    if (options.format !== "jpeg" && (0,_helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) {
        options.format = "webp";
    }
    var cacheKey = "resizedImage.".concat(JSON.stringify(options));
    var cachedResult = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() ? null : localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(cacheKey);
    var image = (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__.useApolloQuery)(_objectSpread({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__["default"])(_templateObject()),
        variables: options,
        omit: !!cachedResult || !options.fileId || (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()
    }, queryOpts)).image;
    if (!options.fileId) return null;
    if (cachedResult) return cachedResult;
    if (!image) return null;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, image.resizedURL);
    return image.resizedURL;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DEFAULT_DESKTOP_WIDTH; },
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony export DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 20024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_8MuG23SExovTPxJNAoEG8"};

/***/ })

}]);